export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7455.65a7cd78.jpg";